import React from "react";

const ShotsIndicator = ({ total, used, controlsHeight, refer }) => {
  const remaining = total - used;

  const CENTER_INDEX = 2;
  const SLOT_COUNT = 5;

  const slots = Array.from({ length: SLOT_COUNT }, (_, index) => {
    const offset = index - CENTER_INDEX;

    // Lock center at 1 when remaining <= 1
    const base = remaining <= 1 ? 1 : remaining;

    return base - offset;
  });

  return (
    <div 
      className="shots-indicator"
      style={{ bottom: `${controlsHeight + 32}px` }}
      ref={refer}
    >
      {slots.map((value, index) => {
        const isActive = index === CENTER_INDEX;

        if (value <= 0 || value > total) {
          return (
            <div
              key={index}
              className="shot empty"
            />
          );
        }

        return (
          <div
            key={index} // 🔥 stable slot key (important)
            className={`shot ${isActive ? "active" : "disabled"}`}
            data-active={isActive}
          >
            <span className="number">{value}</span>
            <span className="label">shot{value === 1 ? "" : "s"}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ShotsIndicator;
